<div class="overlay-loader" *ngIf="isLoading">
    <div class="spinner-box">
        <mat-spinner diameter="40"></mat-spinner>
    </div>
</div>
<div class="orders-container" *ngIf="advanceRequests$ | async as advanceRequests">
    <mat-card>
        <mat-card-title>Salary Advance Request Status</mat-card-title>
        <mat-card-content>
            <!-- <table mat-table [dataSource]="aadvanceRequests" class="mat-elevation-z2 orders-table"> -->
            <table mat-table [dataSource]="advanceRequests | slice:(pageIndex * pageSize):((pageIndex + 1) * pageSize)"
                class="mat-elevation-z2 orders-table">
                <ng-container matColumnDef="slno">
                    <th mat-header-cell *matHeaderCellDef> Sl No. </th>
                    <td mat-cell *matCellDef="let item; let i = index"> {{ (pageIndex * pageSize) + i + 1 }} </td>
                </ng-container>

                <ng-container matColumnDef="employee_no">
                    <th mat-header-cell *matHeaderCellDef> Employee No. </th>
                    <td mat-cell *matCellDef="let item">{{item.employee_no}}</td>
                </ng-container>

                <ng-container matColumnDef="employee_name">
                    <th mat-header-cell *matHeaderCellDef> Employee Name </th>
                    <td mat-cell *matCellDef="let item"> {{ item.employee_name }} </td>
                </ng-container>

                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef> Amount </th>
                    <td mat-cell *matCellDef="let item"> {{ item.amount }} </td>
                </ng-container>

                <ng-container matColumnDef="request_date">
                    <th mat-header-cell *matHeaderCellDef> Requested Date </th>
                    <td mat-cell *matCellDef="let item"> {{ item.request_date | date:'dd-MM-yyyy' }} </td>
                </ng-container>

                <ng-container matColumnDef="return_date">
                    <th mat-header-cell *matHeaderCellDef> Return Date </th>
                    <td mat-cell *matCellDef="let item"> {{ item.return_date | date:'dd-MM-yyyy' }} </td>
                </ng-container>

                <ng-container matColumnDef="number_of_days">
                    <th mat-header-cell *matHeaderCellDef> No. of Days </th>
                    <td mat-cell *matCellDef="let item"> {{ item.number_of_days }} </td>
                </ng-container>

                <ng-container matColumnDef="approval_status">
                    <th mat-header-cell *matHeaderCellDef> Approval Status </th>
                    <td mat-cell *matCellDef="let item"> {{ item.approval_status }} </td>
                </ng-container>

                <ng-container matColumnDef="reason">
                    <th mat-header-cell *matHeaderCellDef> Reason </th>
                    <td mat-cell *matCellDef="let item">
                        <span class="ellipsis-text" [matTooltip]="item.reason">
                            {{ item.reason }}
                        </span>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

            </table>

            <mat-paginator [length]="advanceRequests.length" *ngIf="advanceRequests.length > 5" [pageSize]="pageSize"
                [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons (page)="onPageChange($event)">
            </mat-paginator>
        </mat-card-content>
    </mat-card>
</div>